import { CustomValue, Lead, Task } from '@/types';

export default {
  tasksCompleted(lead: Lead) {
    if (lead.Tasks) {
      // eslint-disable-next-line no-restricted-syntax
      for (const task of lead.Tasks.filter((t) => t.status !== 'disabled')) {
        if (task.status !== 'completed') {
          return false;
        }
      }

      return true;
    }

    return false;
  },

  taskRowClass(task: Task) {
    // if (task.relationship === 'father') {
    //   return 'child';
    // }

    if (task.status === 'error') {
      return `${task.name} wrong`;
    }
    if (task.status === 'completed') {
      return `${task.name} done`;
    }
    if (task.status === 'disabled') {
      return `${task.name} unknown`;
    }

    return `${task.name} unknown`;
  },

  taskIconClass(task: Task) {
    // if (task.relationship === 'father') {
    //   return 'glyphicon-circle-arrow-right';
    // }

    if (task.status === 'error') {
      return 'glyphicon-remove-circle';
    }
    if (task.status === 'completed') {
      return 'glyphicon-ok-circle';
    }
    if (task.status === 'disabled') {
      return 'glyphicon-ban-circle';
    }
    return 'glyphicon-question-sign';
  },

  getCustomValueTextByName(lead: Lead, name: string) {
    if (Array.isArray(lead.CustomValues) && lead.CustomValues.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const cv of lead.CustomValues) {
        if (cv.name === name) {
          return cv.value;
        }
      }
    }

    return null;
  },

  getCustomValueDateByName(lead: Lead, name: string) {
    if (Array.isArray(lead.CustomValues) && lead.CustomValues.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const cv of lead.CustomValues) {
        if (cv.name === name) {
          return cv.dateValue;
        }
      }
    }

    return null;
  },

  getCustomValueIntegerByName(lead: Lead, name: string): number | null | undefined {
    if (Array.isArray(lead.CustomValues) && lead.CustomValues.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const cv of lead.CustomValues) {
        if (cv.name === name) {
          return cv.integerValue;
        }
      }
    }

    return null;
  },

  getCustomValueUserIdByName(lead: Lead, name: string): number | null {
    if (Array.isArray(lead.CustomValues) && lead.CustomValues.length > 0) {
      // eslint-disable-next-line no-restricted-syntax
      for (const cv of lead.CustomValues) {
        if (cv.name === name) {
          return cv.userValueId;
        }
      }
    }

    return null;
  },

  getPrevTask(lead: Lead, name: string) {
    let prevTask: Task | null = null;

    if (lead.Tasks) {
      // eslint-disable-next-line no-restricted-syntax
      for (const task of lead.Tasks.filter((t) => t.status !== 'disabled')) {
        if (task.name === name) {
          break;
        }

        prevTask = task;
      }
    }

    return prevTask;
  },

  getNextTask(lead: Lead, name: string) {
    let nextTask: Task | null = null;

    if (lead.Tasks) {
      // Inverte l'ordine dei task
      const reversedTasks = [...lead.Tasks].reverse();

      // eslint-disable-next-line no-restricted-syntax
      for (const task of reversedTasks.filter((t) => t.status !== 'disabled')) {
        if (task.name === name) {
          break;
        }

        nextTask = task;
      }
    }

    return nextTask;
  },

  getCustomValueBooleanByName(lead: Lead, name: string): boolean | null {
    if ('CustomValues' in lead === false
      || !Array.isArray(lead.CustomValues)
      || lead.CustomValues.length === 0) {
      return null;
    }

    const cv = lead.CustomValues.find((v) => v.name === name);

    if (!cv) return null;

    return cv.booleanValue !== undefined ? cv.booleanValue : null;
  },

  tasksWithErrors(lead: Lead) {
    if (lead.Tasks) {
      // eslint-disable-next-line no-restricted-syntax
      for (const task of lead.Tasks) {
        if (task.status === 'error') {
          return true;
        }
      }
    }

    return false;
  },
};
